var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('section', {
    staticClass: "ugc-image-upload-wrapper"
  }, [_c('div', {
    staticClass: "ugc-image-upload-input-file-wrapper"
  }, [_vm.tmallEnabled && _vm.isMy ? _c('input', {
    ref: _vm.inputId,
    staticClass: "hide ugc-image-source",
    attrs: {
      "id": _vm.inputId,
      "type": "button",
      "accept": "image/jpg,image/jpeg,image/png",
      "name": _vm.inputId
    },
    on: {
      "click": _vm.setUGCImageTmall
    }
  }) : _c('input', {
    ref: _vm.inputId,
    staticClass: "hide ugc-image-source",
    attrs: {
      "id": _vm.inputId,
      "type": "file",
      "accept": "image/jpg,image/jpeg,image/png",
      "name": _vm.inputId
    },
    on: {
      "change": _vm.setUGCImage
    }
  }), _c('div', {
    staticClass: "ugc-image-upload-input-file-trigger-wrapper"
  }, [_c('button', {
    staticClass: "ugc-uploader-label button ugc-tray-wrapper-button",
    attrs: {
      "id": "imageUploadInputFileTrigger",
      "disabled": _vm.disableButton || _vm.isGCC
    },
    on: {
      "click": _vm.onUploadClick
    }
  }, [_vm.displayIcon ? _c('span', {
    staticClass: "icon icon-camera"
  }) : _vm._e(), _vm._v("\n        " + _vm._s(_vm.textLabel || _vm.translations[_vm.inputLabel]) + "\n      ")])])])]);
}
var staticRenderFns = []

export { render, staticRenderFns }